import React from "react";
import { IMAGES, TEAM } from "../mock";
import { Reveal, PageHero } from "../components/Shared";
import Seo from "../components/Seo";

const TEAM_JSONLD = TEAM.map((m) => ({
  "@context": "https://schema.org",
  "@type": "Person",
  name: m.name,
  jobTitle: m.role,
  image: m.image,
  worksFor: { "@type": "Organization", name: "Global Equine Group" },
}));

export default function Team() {
  return (
    <div data-testid="team-page">
      <Seo
        title="The Team"
        description="Meet the Global Equine Group team: Adam Driver (Managing Director & equine veterinarian), Rebecca Hegarty (Assistant Racing Manager) and Elbashir Elhrari (Racing Manager, MENA)."
        image={IMAGES.heroTeam}
        jsonLd={TEAM_JSONLD}
      />
      <PageHero image={IMAGES.heroTeam} kicker="The People Behind The Success" title="The Team">
        <p className="text-[#b9c9d6] mt-6 max-w-2xl text-lg leading-relaxed">
          Consultants from the bloodstock industry, experts from the equine scientific community,
          racehorse owners, specialist farriers and experienced equine veterinarians — the first
          complete equine consultant service based on professionalism, transparency and value.
        </p>
      </PageHero>

      <section className="py-24 bg-white">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12 flex flex-col gap-24">
          {TEAM.map((member, idx) => (
            <div
              key={member.id}
              className="grid md:grid-cols-5 gap-10 lg:gap-16 items-start"
              data-testid={`team-member-${member.id}`}
            >
              <Reveal className={`md:col-span-2 ${idx % 2 === 1 ? "md:order-2" : ""}`}>
                <div className="relative">
                  <div className={`absolute w-full h-full border-2 border-[#eaf5fc] hidden md:block ${idx % 2 === 1 ? "-bottom-5 -right-5" : "-bottom-5 -left-5"}`} />
                  <div className="gee-img-frame aspect-square relative">
                    <img src={member.image} alt={member.name} loading="lazy" />
                  </div>
                </div>
              </Reveal>
              <div className={`md:col-span-3 ${idx % 2 === 1 ? "md:order-1" : ""}`}>
                <Reveal>
                  <p className="gee-kicker mb-3">{member.role}</p>
                  <h2 className="font-serif-d text-[#0f2438] text-3xl md:text-4xl mb-5">{member.name}</h2>
                  <div className="gee-divider mb-8" />
                </Reveal>
                <Reveal delay={1}>
                  <div className="space-y-5">
                    {member.bio.map((para, i) => (
                      <p key={para.slice(0, 60)} className="text-[#5b6d7d] leading-relaxed">{para}</p>
                    ))}
                  </div>
                </Reveal>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA band */}
      <section style={{ backgroundColor: "#0f2438" }} className="py-20">
        <div className="max-w-[900px] mx-auto px-6 lg:px-12 text-center">
          <Reveal>
            <h2 className="font-serif-d text-white text-3xl md:text-4xl mb-4">
              Ready to start your ownership journey?
            </h2>
            <p className="text-[#7d94a6] mb-8">
              Get in touch and let us help you every step of the way.
            </p>
            <a href="#contact" className="gee-btn" data-testid="team-contact-btn">
              Contact Us
            </a>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
